import { useGetPageMode } from '@confluence/page-utils/entry-points/useGetPageMode';
import { useLivePageMode } from '@confluence/live-pages-utils/entry-points/useLivePagesStore';
import { PageMode } from '@confluence/page-utils/entry-points/enums';

/**
 * Custom hook that determines if the page is in view mode.
 * Encapsulates all the page mode logic and hook calls.
 *
 * @returns true if the page is in view mode, false if in edit mode
 *
 * Logic:
 * - VIEW mode: always view mode (true)
 * - EDIT mode: always edit mode (false)
 * - LIVE mode: depends on isViewMode from useLivePageMode
 * - Unknown mode: defaults to view mode (true) to mirror pageMode defaulting to VIEW
 */
export function useIsPageViewMode(): boolean {
	const pageMode = useGetPageMode();
	const [{ isViewMode }] = useLivePageMode();

	// Handle each page mode explicitly
	if (pageMode === PageMode.EDIT) {
		return false;
	}

	if (pageMode === PageMode.LIVE) {
		return isViewMode;
	}

	// PageMode.VIEW or unknown modes default to view mode
	return true;
}
